import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { initGA, track } from "../lib/api";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("sb8_cookie_consent")) setVisible(true);
    else initGA();
  }, []);

  const choose = (choice) => {
    localStorage.setItem("sb8_cookie_consent", choice);
    setVisible(false);
    track(choice === "accepted" ? "cookie_accept" : "cookie_refuse");
    if (choice === "accepted") initGA();
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-4" data-testid="cookie-banner">
      <div className="max-w-3xl mx-auto border border-[#2E333D] bg-[#141619]/95 backdrop-blur-xl rounded-2xl p-5 sm:p-6 shadow-2xl shadow-black/60">
        <div className="flex items-start gap-4">
          <Cookie size={22} className="text-[#FFC700] shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm text-gray-300 leading-relaxed">
              Nous utilisons des cookies de mesure d'audience pour analyser l'intérêt des visiteurs
              et améliorer le projet STOCKBOX 8. Vous pouvez accepter ou refuser.
              Consultez notre <a href="/politique-cookies" className="underline hover:text-[#FFC700]">politique cookies</a>.
            </p>
            <div className="mt-4 flex flex-col sm:flex-row gap-3">
              <button onClick={() => choose("accepted")} data-testid="cookie-accept-button"
                className="bg-[#FFC700] text-[#0C0D0E] font-semibold text-sm px-6 py-2.5 rounded-full hover:bg-[#FFD83D] transition-colors">
                Accepter
              </button>
              <button onClick={() => choose("refused")} data-testid="cookie-refuse-button"
                className="border border-[#2E333D] text-gray-300 font-semibold text-sm px-6 py-2.5 rounded-full hover:border-gray-500 transition-colors">
                Refuser
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
